module.exports = __webpack_public_path__ + "img/supplier-icon.4556e87a.svg";